import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import {store}                               from './store';
import {Provider}                            from 'react-redux';
import ErrorPage from './ErrorPage'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

const router = createBrowserRouter([
  {
    path: '/portal',
    element: <App/>,
    errorElement: <ErrorPage/>
  },
  {
    path: '*',
    element: <ErrorPage message="Invalid URL. Please ensure you're accessing the portal with the correct URL."/>
  }
])

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router}/>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
